<template>
	<div class="customerservice">
		<img src="../assets/kefuimg.png" @click="open53()" />
	</div>
</template>

<script>
	export default {
		name: 'Customerservice',
		data() {
			return {

			}
		},
		methods: {

		},
		components: {

		},
	}
</script>

<style>
	.customerservice img {
		width: 2.5rem;
		height: 2.5rem;
		position: fixed;
		bottom: 3.5rem;
		right: 1rem;
		z-index: 9999999999;
	}
</style>



// WEBPACK FOOTER //
// src/components/customerservice.vue